import request from '@/utils/request'

let ChannelApi = {
  /*渠道端设置*/
  ChannelsetDetail(data, errorback) {
    return request._get('/shop/setting.Channel/index', data, errorback);
  },
  Channelset(data, errorback) {
    return request._post('/shop/setting.Channel/index', data, errorback);
  },
  /*渠道端用户*/
  ChanneluserDetail(data, errorback) {
    return request._post('/shop/channel.index/details', data, errorback);
  },
  ChannelUser(data, errorback) {
    return request._post('/shop/channel.index/index', data, errorback);
  },
  ChanneloneAgent(data, errorback) {
    return request._get('/shop/channel.index/oneAgent', data, errorback);
  },
  ChanneluserAdd(data, errorback) {
    return request._post('/shop/channel.index/add', data, errorback);
  },
  ChanneluserEdit(data, errorback) {
    return request._post('/shop/channel.index/edit', data, errorback);
  },
  // 渠道提现列表
  WithdrawalList(data, errorback) {
    return request._post('/shop/channel.Withdrawal/index', data, errorback);
  },
  editStatus(data, errorback) {
    return request._post('/shop/channel.Withdrawal/editStatus', data, errorback);
  },
  channeldelete(data, errorback) {
    return request._get('/shop/channel.index/del', data, errorback);
  },
  obimg(data, errorback) {
    return request._post('/shop/channel.index/getQrCode', data, errorback);
  },
  changepassword(data, errorback) {
    return request._post('/shop/channel.index/setPass', data, errorback);
  },
}

export default ChannelApi;



// WEBPACK FOOTER //
// ./src/api/channel.js